import moment from 'moment'
import {
    ContainerAvailabilityForecastContainerStatuses,
} from 'app/enums/common.enums'

const getOptions = ({
    categories,
    minPreconditioned,
    customTooltip,
    containerStatus,
    maxValue,
    theme,
}: {
    categories: string[],
    minPreconditioned: number,
    customTooltip: (args: any) => string,
    containerStatus: Record<string, boolean>,
    maxValue: number,
    theme: Record<string, any>,
}) => {
    const colorSet = {
        [ContainerAvailabilityForecastContainerStatuses.ToBeProcessed]: ({
            value,
        }) => {
            return value < 0 ? theme.palette.common.red : theme.palette.common.beige
        },
        [ContainerAvailabilityForecastContainerStatuses.InProcess]: ({
            value,
        }) => {
            return value < 0 ? theme.palette.common.red : theme.palette.common.yellow
        },
        [ContainerAvailabilityForecastContainerStatuses.Processed]: ({
            value,
        }) => {
            return value < 0 ? theme.palette.common.red : theme.palette.primary[300]
        },
        [ContainerAvailabilityForecastContainerStatuses.InPreconditioning]: ({
            value,
        }) => {
            return value < 0 ? theme.palette.common.red : theme.palette.primary[500]
        },
        [ContainerAvailabilityForecastContainerStatuses.Preconditioned]: ({
            value,
        }) => {
            return value < minPreconditioned ? theme.palette.common.red : theme.palette.primary[700]
        },
    }

    const seriesColors = Object.entries(containerStatus).reduce((acc, [
        status,
        active,
    ]) => {
        if (active) {
            acc.push(colorSet[status])
        }

        return acc
    }, [])

    return {
        legend: {
            horizontalAlign: 'left',
        } as ApexLegend,
        tooltip: {
            custom: customTooltip,
        },
        chart: {
            id: 'basic-bar',
            toolbar: {
                show: true,
                offsetX: -60,
                offsetY: 0,
                tools: {
                    download: '<img src="/assets/images/download_button.svg" width="24px" height="24px" alt="download"/>',
                },
            },
        },
        yaxis: {
            max: maxValue + 2,
            min: 0,
            labels: {
                formatter(val) {
                    return val.toFixed(0)
                },
            },
        },
        xaxis: {
            categories,
            labels: {
                formatter(value) {
                    return moment(value, 'DD.MM.YYYY').format('DD.MM')
                },
            },
        },
        colors: seriesColors,
        dataLabels: {
            enabled: false,
        },
        grid: {
            padding: {
                right: 70,
                top: 20,
            },
            xaxis: {
                lines: {
                    show: true,
                },
                min: 0,
            },
            strokeDashArray: 7,
        },
        annotations: {
            yaxis: [{
                y: minPreconditioned,
                strokeDashArray: 10,
                borderColor: theme.palette.primary[600],
                label: {
                    style: {
                        fontSize: '15px',
                        color: theme.palette.primary[600],
                        background: 'none',
                    },
                    offsetX: 70,
                    textAnchor: 'end',
                    borderWidth: 0,
                    text: 'Min Precon',
                },
            }],
        },
    }
}

export default getOptions
